import React from 'react';
import styles from './index.module.scss';

import { UiKit } from 'components';

/**
 * Asks the signed-in user to confirm before a sign-in link replaces their
 * current session.
 * @param {Object} props
 * @param {string} props.currentStore Store the browser is currently signed in to
 * @param {string} [props.targetStore] Store named in the link (unverified)
 * @param {() => void} props.onConfirm
 * @param {() => void} props.onCancel
 */
export default function ConfirmSessionSwitch({
  currentStore = '',
  targetStore = '',
  onConfirm = () => {},
  onCancel = () => {}
}) {
  return (
    <UiKit.Flex
      direction="column"
      align="center"
      justify="center"
      className={styles.container}
    >
      <UiKit.Flex
        direction="column"
        gap={16}
        align="center"
        justify="center"
        className={styles.content}
      >
        <UiKit.Title>Switch account?</UiKit.Title>
        <UiKit.Text size="lg" variant={700} className={styles.message}>
          You are currently signed in to <strong>"{currentStore}"</strong>. This
          link will sign you out and sign you in to{' '}
          {targetStore ? <strong>"{targetStore}"</strong> : 'another account.'}
        </UiKit.Text>
        <UiKit.Text size="lg" variant={700}>
          Do you want to continue?
        </UiKit.Text>
        <UiKit.Flex gap={8}>
          <UiKit.Button onClick={onConfirm}>Switch account</UiKit.Button>
          <UiKit.Button variant="secondary" outline onClick={onCancel}>
            Stay signed in
          </UiKit.Button>
        </UiKit.Flex>
      </UiKit.Flex>
    </UiKit.Flex>
  );
}
